import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function About() {
  const stats = [
    { value: '10,000+', label: '漫画资源' },
    { value: '5,000万+', label: '月活用户' },
    { value: '8年', label: '行业深耕' },
    { value: '200+', label: '合作作者' },
  ];

  const milestones = [
    { year: '2018', title: '平台创立', desc: '虫虫漫画正式上线，致力于打造国内最优质的漫画阅读平台。' },
    { year: '2019', title: '百万用户', desc: '注册用户突破100万，成为漫画爱好者首选平台之一。' },
    { year: '2020', title: '版权合作', desc: '与超过100位漫画家达成版权合作，引入大量优质原创作品。' },
    { year: '2022', title: '千万里程碑', desc: '月活用户突破千万，成为国内领先的在线漫画平台。' },
    { year: '2024', title: '国际化布局', desc: '开始国际化探索，将优质国漫推向全球读者。' },
    { year: '2026', title: '持续创新', desc: '持续技术创新与内容深耕，为用户带来更极致的漫画阅读体验。' },
  ];

  const faqs = [
    {
      q: '虫虫漫画是否完全免费？',
      a: '是的！虫虫漫画平台上的所有漫画资源均免费向用户开放阅读，无需付费订阅。',
    },
    {
      q: '漫画资源多久更新一次？',
      a: '我们与多家漫画平台同步更新，热门漫画基本保持每日更新，确保您第一时间看到最新内容。',
    },
    {
      q: '支持在哪些设备上阅读？',
      a: '虫虫漫画支持PC端、手机端和平板端访问，自动适配不同屏幕尺寸，随时随地畅享阅读。',
    },
    {
      q: '如何联系虫虫漫画团队？',
      a: '您可以通过邮箱 contact@chongchongcomic.com 或客服电话 400-888-6666 联系我们，我们会在24小时内回复。',
    },
    {
      q: '我可以投稿原创漫画吗？',
      a: '当然可以！我们欢迎原创漫画家入驻。请将作品和简介发送至投稿邮箱 submission@chongchongcomic.com。',
    },
  ];

  return (
    <>
      <Header />
      <main>
        {/* Breadcrumb */}
        <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 pt-24 pb-0 bg-background-50">
          <div className="max-w-[1400px] mx-auto">
            <ol className="flex items-center gap-2 text-xs text-foreground-500">
              <li>
                <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <i className="ri-arrow-right-s-line"></i>
              </li>
              <li className="text-foreground-800 font-medium">关于我们</li>
            </ol>
          </div>
        </nav>

        {/* Brand Introduction */}
        <section className="w-full px-4 md:px-6 pt-8 pb-16 md:pb-20 bg-background-50" aria-labelledby="about-title">
          <div className="max-w-[1400px] mx-auto">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-600 bg-primary-50 rounded-full mb-4">
              关于虫虫漫画
            </span>
            <h1 id="about-title" className="text-3xl md:text-5xl font-heading text-foreground-950">
              最新最全的在线漫画平台
            </h1>
            <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-3xl leading-relaxed">
              虫虫漫画成立于2018年，作为最新最全的漫画官网，我们致力于为广大漫画爱好者提供免费、优质的在线漫画阅读服务。平台资源权威且全面，更新同步，是漫画爱好者信赖的官方渠道。
            </p>

            <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-5">
              {stats.map((stat) => (
                <div key={stat.label} className="p-5 rounded-lg bg-background-100 text-center">
                  <div className="text-2xl md:text-3xl font-heading text-primary-500">{stat.value}</div>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Brand Story / Milestones */}
        <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100" aria-labelledby="story-title">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <h2 id="story-title" className="text-2xl md:text-4xl font-heading text-foreground-950">
                品牌发展历程
              </h2>
              <p className="mt-3 text-sm text-foreground-600">从创立到壮大，每一步都脚踏实地</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {milestones.map((item) => (
                <div
                  key={item.year}
                  className="p-5 md:p-6 rounded-lg bg-background-50 hover:bg-background-200/70 transition-colors"
                >
                  <span className="text-sm font-bold text-primary-500">{item.year}</span>
                  <h3 className="mt-2 text-base font-heading text-foreground-900">{item.title}</h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact & FAQ */}
        <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50" aria-labelledby="contact-title">
          <div className="max-w-[1400px] mx-auto">
            <div className="mb-12 md:mb-16">
              <h2 id="contact-title" className="text-2xl md:text-4xl font-heading text-foreground-950 text-center">
                联系我们
              </h2>
              <p className="mt-3 text-sm text-foreground-600 text-center">
                有任何问题或建议？我们随时为您服务
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
              {/* Contact Info */}
              <div>
                <h3 className="text-lg font-heading text-foreground-900 mb-6">联系方式</h3>
                <div className="space-y-5">
                  <div className="flex items-start gap-4 p-4 rounded-lg bg-background-100">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">公司地址</p>
                      <p className="text-sm text-foreground-600 mt-0.5">北京市朝阳区漫画产业园A座</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 p-4 rounded-lg bg-background-100">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-phone-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">客服电话</p>
                      <p className="text-sm text-foreground-600 mt-0.5">400-888-6666</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 p-4 rounded-lg bg-background-100">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">电子邮箱</p>
                      <p className="text-sm text-foreground-600 mt-0.5">contact@chongchongcomic.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 p-4 rounded-lg bg-background-100">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-time-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">工作时间</p>
                      <p className="text-sm text-foreground-600 mt-0.5">周一至周日 9:00 - 22:00</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* FAQ */}
              <div>
                <h3 className="text-lg font-heading text-foreground-900 mb-6">常见问题</h3>
                <div className="space-y-3">
                  {faqs.map((faq, idx) => (
                    <details key={idx} className="group rounded-lg bg-background-100 overflow-hidden">
                      <summary className="flex items-center justify-between p-4 cursor-pointer text-sm font-medium text-foreground-900 hover:text-primary-500 transition-colors">
                        {faq.q}
                        <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                      </summary>
                      <div className="px-4 pb-4 text-sm text-foreground-600 leading-relaxed">
                        {faq.a}
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
          <div className="max-w-[1400px] mx-auto text-center">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
              加入虫虫漫画
              <br />
              发现无限精彩
            </h2>
            <p className="mt-4 text-base text-foreground-600 max-w-lg mx-auto">
              现在就开启你的漫画之旅，海量正版漫画免费看！
            </p>
            <Link
              to="/category/xuanhuan"
              className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 text-sm font-medium text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              开始阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>
      <Footer />

      {/* FAQPage Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.a,
              },
            })),
          }),
        }}
      />
      {/* BreadcrumbList Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.chongchongcomic.com',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '关于我们',
              },
            ],
          }),
        }}
      />
    </>
  );
}